import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { DATE_SHORT } from 'utils/formatters/date'
import { EN_DASH_DEFAULT_VALUE, SSN_PLACEHOLDER } from 'utils/constants/defaultValues'
import { Row } from 'components/grid/Row'
import { Col } from 'components/grid/Col'
import { FormBlock } from 'components/formBlock/FormBlock'
import { FormInput } from 'components/form/input/FormInput'
import { FormSSN } from 'components/form/ssn/FormSSN'

import styles from './ApplicantInfo.module.scss'
import { formTypes } from 'utils/constants/formTypes'

export const ApplicantInfo = ({ form, formData, handleFieldChange }) => {
  const isMiForm = form?.type === formTypes.MI_EMPLOYMENT_REFERENCE
  const showDob = !isMiForm

  return (
    <div className={styles.applicantInfo}>
      <Row>
        <Col size={3}>
          <FormInput
            isReadonly
            title="First Name"
            placeholder="First Name"
            field={formData.firstName}
            onChange={handleFieldChange(`firstName`)}
          />
        </Col>
        <Col size={3}>
          <FormInput
            isReadonly
            title="Middle Name"
            placeholder="Middle Name"
            field={formData.middleName}
            onChange={handleFieldChange(`middleName`)}
          />
        </Col>
        <Col size={3}>
          <FormInput
            isReadonly
            title="Last Name"
            placeholder="Last Name"
            field={formData.lastName}
            onChange={handleFieldChange(`lastName`)}
          />
        </Col>
        <Col size={3}>
          <FormInput
            isReadonly
            title="Maiden Name"
            placeholder="Maiden Name"
            field={formData.maidenName}
            onChange={handleFieldChange(`maidenName`)}
          />
        </Col>
      </Row>
      <Row topIndent>
        {showDob && (
          <Col size={3}>
            <FormBlock
              title="Date of Birth"
              readonlyView={
                !formData.birthday.value ? EN_DASH_DEFAULT_VALUE : moment(formData.birthday.value).format(DATE_SHORT)
              }
              isReadonly={true}
              isRequired={false}>
              &nbsp;
            </FormBlock>
          </Col>
        )}

        <Col size={3}>
          <FormSSN
            isReadonly
            title="SSN"
            placeholder={SSN_PLACEHOLDER}
            field={formData.ssn}
            onChange={handleFieldChange(`ssn`)}
          />
        </Col>
      </Row>
    </div>
  )
}

ApplicantInfo.propTypes = {
  form: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
}
